<h3 class="md-subhead">Statistic:</h3>
<div class="mat-typography content">
    <app-process-status-row [process]="process"></app-process-status-row>
    <p>Land Uses in the file: {{
        process.originalRowsCount }}</p>
    <p>Land Uses to process: {{
        process.totalPropertyRecords }}</p>
    <p>Processed Land Uses: {{
        process.currentOffsetIndex }}</p>
    <p>Progress: {{ process.progress }}%</p>
</div>